import { TimekeeperService } from "services/TimekeeperService";

const tk = new TimekeeperService();

interface Paycode {
    paycode_id: number;
    name: string;
}

interface Combination {
    paycode_id: number;
    paycode_combination_id: number;
    start_date: string;
    end_date: string;
}

interface PaycodeCombination {
    id: number;
    name: string;
    end_date: string;
    start_date: string;
    enable: boolean;
    paycodes: Paycode[];
    combinations: Combination[];
}

type SetLoading = (loading: boolean) => void;
type SetRows = (rows: PaycodeCombination[]) => void;

type Body = Record<string, any>;

type Ids = number[];

const gettingPycodesCombination = async (setLoading: SetLoading, setRows: SetRows): Promise<void> => {
    setLoading(true);

    tk.paycodes_combination.getAll()
        .then((response: PaycodeCombination[]) => {
            setRows(response);
        })
        .catch((error: Error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const createPycodesCombination = async (setLoading: SetLoading, body: Body): Promise<any> => {
    setLoading(true);
    return await tk.paycodes_combination.create(body);
};

const deletePycodesCombination = async (setLoading: SetLoading, ids: Ids): Promise<any> => {
    setLoading(true);
    return await tk.paycodes_combination.delete(ids);
};

const gettingPaycodes = async (setLoading: SetLoading): Promise<any> => {
    setLoading(true);
    return await tk.paycodes.getPaycodes("paycode_combination");
};

const editPycodesCombination = async (setLoading: SetLoading, id: number, data: Body): Promise<any> => {
    setLoading(true);
    return await tk.paycodes_combination.update(id, data);
};

export {
    gettingPycodesCombination,
    gettingPaycodes,
    createPycodesCombination,
    deletePycodesCombination,
    editPycodesCombination
};